import React from "react";

const TrustedPartner = () => {
  return (
    <section>
      <div className={"w-full max-w-[1320px] mx-auto px-5 pt-28"}>
        <h2 className="text-center text-[28px] text-[#21272A]">
          <strong className="block text-[36px] leading-[1.4]">
            Your Trusted Partner for Smarter Crypto Trading
          </strong>
        </h2>

        <div className="grid md:grid-cols-3 mt-14 gap-12 px-12">
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40 20V16C40 15.4696 39.7893 14.9609 39.4142 14.5858C39.0391 14.2107 38.5304 14 38 14H36V16C36 16.5304 35.7893 17.0391 35.4142 17.4142C35.0391 17.7893 34.5304 18 34 18C33.4696 18 32.9609 17.7893 32.5858 17.4142C32.2107 17.0391 32 16.5304 32 16V14H16V16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18C13.4696 18 12.9609 17.7893 12.5858 17.4142C12.2107 17.0391 12 16.5304 12 16V14H10C9.46957 14 8.96086 14.2107 8.58579 14.5858C8.21071 14.9609 8 15.4696 8 16V20H40ZM40 24H8V36C8 36.5304 8.21071 37.0391 8.58579 37.4142C8.96086 37.7893 9.46957 38 10 38H38C38.5304 38 39.0391 37.7893 39.4142 37.4142C39.7893 37.0391 40 36.5304 40 36V24ZM36 10H38C39.5913 10 41.1174 10.6321 42.2426 11.7574C43.3679 12.8826 44 14.4087 44 16V36C44 37.5913 43.3679 39.1174 42.2426 40.2426C41.1174 41.3679 39.5913 42 38 42H10C8.4087 42 6.88258 41.3679 5.75736 40.2426C4.63214 39.1174 4 37.5913 4 36V16C4 14.4087 4.63214 12.8826 5.75736 11.7574C6.88258 10.6321 8.4087 10 10 10H12V8C12 7.46957 12.2107 6.96086 12.5858 6.58579C12.9609 6.21071 13.4696 6 14 6C14.5304 6 15.0391 6.21071 15.4142 6.58579C15.7893 6.96086 16 7.46957 16 8V10H32V8C32 7.46957 32.2107 6.96086 32.5858 6.58579C32.9609 6.21071 33.4696 6 34 6C34.5304 6 35.0391 6.21071 35.4142 6.58579C35.7893 6.96086 36 7.46957 36 8V10Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              Non-Custodial for Complete Security
            </h4>
            <p className="text-base text-center px-8">
              Your funds stay in your exchange account. Trade safely without
              transferring assets to a third party.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34 19.9999V35.9999H30V19.9999H18V35.9999H14V19.9999C12.4087 19.9999 10.8826 20.632 9.75736 21.7572C8.63214 22.8825 8 24.4086 8 25.9999V29.9999C8 31.5912 8.63214 33.1173 9.75736 34.2425C10.8826 35.3677 12.4087 35.9999 14 35.9999H34C35.5913 35.9999 37.1174 35.3677 38.2426 34.2425C39.3679 33.1173 40 31.5912 40 29.9999V25.9999C40 24.4086 39.3679 22.8825 38.2426 21.7572C37.1174 20.632 35.5913 19.9999 34 19.9999ZM18.34 15.9999H29.66C29.244 14.8315 28.4767 13.8205 27.4634 13.1056C26.45 12.3907 25.2402 12.0069 24 12.0069C22.7598 12.0069 21.55 12.3907 20.5366 13.1056C19.5233 13.8205 18.756 14.8315 18.34 15.9999ZM14.2 15.9999C14.663 13.7426 15.891 11.7143 17.6765 10.2578C19.4621 8.80132 21.6957 8.00586 24 8.00586C26.3043 8.00586 28.5379 8.80132 30.3235 10.2578C32.109 11.7143 33.337 13.7426 33.8 15.9999H34C36.6522 15.9999 39.1957 17.0534 41.0711 18.9288C42.9464 20.8042 44 23.3477 44 25.9999V29.9999C44 32.652 42.9464 35.1956 41.0711 37.0709C39.1957 38.9463 36.6522 39.9999 34 39.9999H14C11.3478 39.9999 8.8043 38.9463 6.92893 37.0709C5.05357 35.1956 4 32.652 4 29.9999V25.9999C4 23.3477 5.05357 20.8042 6.92893 18.9288C8.8043 17.0534 11.3478 15.9999 14 15.9999H14.2Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              Transparent Subscription Fees
            </h4>
            <p className="text-base text-center px-8">
              No hidden charges or profit-sharing. Enjoy predictable costs with
              a clear subscription-based model.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.232 27.4981L16 9.89612L13.768 27.4961H6C4.896 27.4961 4 26.6221 4 25.5441C4.00633 25.0197 4.22048 24.5192 4.59544 24.1525C4.97041 23.7857 5.47555 23.5828 6 23.5881H10.232L12.032 9.41612C12.3 7.27212 14.3 5.75212 16.49 6.01612C18.31 6.23612 19.742 7.63612 19.968 9.41612L21.766 23.5881H25.714L28 38.0801L30.284 23.5901H42C43.104 23.5901 44 24.4661 44 25.5461C44 26.6261 43.104 27.5001 42 27.5001H33.716L31.954 38.6741C31.8162 39.5035 31.4178 40.2674 30.8165 40.855C30.2152 41.4426 29.4423 41.8234 28.61 41.9421C26.426 42.2721 24.384 40.8081 24.046 38.6741L22.286 27.5001H18.23L18.232 27.4981Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              Dual Learning Tracks
            </h4>
            <p className="text-base text-center px-8">
              Choose between our Trading and Investment Tracks to match your
              goals and learning style.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40 20V16C40 15.4696 39.7893 14.9609 39.4142 14.5858C39.0391 14.2107 38.5304 14 38 14H36V16C36 16.5304 35.7893 17.0391 35.4142 17.4142C35.0391 17.7893 34.5304 18 34 18C33.4696 18 32.9609 17.7893 32.5858 17.4142C32.2107 17.0391 32 16.5304 32 16V14H16V16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18C13.4696 18 12.9609 17.7893 12.5858 17.4142C12.2107 17.0391 12 16.5304 12 16V14H10C9.46957 14 8.96086 14.2107 8.58579 14.5858C8.21071 14.9609 8 15.4696 8 16V20H40ZM40 24H8V36C8 36.5304 8.21071 37.0391 8.58579 37.4142C8.96086 37.7893 9.46957 38 10 38H38C38.5304 38 39.0391 37.7893 39.4142 37.4142C39.7893 37.0391 40 36.5304 40 36V24ZM36 10H38C39.5913 10 41.1174 10.6321 42.2426 11.7574C43.3679 12.8826 44 14.4087 44 16V36C44 37.5913 43.3679 39.1174 42.2426 40.2426C41.1174 41.3679 39.5913 42 38 42H10C8.4087 42 6.88258 41.3679 5.75736 40.2426C4.63214 39.1174 4 37.5913 4 36V16C4 14.4087 4.63214 12.8826 5.75736 11.7574C6.88258 10.6321 8.4087 10 10 10H12V8C12 7.46957 12.2107 6.96086 12.5858 6.58579C12.9609 6.21071 13.4696 6 14 6C14.5304 6 15.0391 6.21071 15.4142 6.58579C15.7893 6.96086 16 7.46957 16 8V10H32V8C32 7.46957 32.2107 6.96086 32.5858 6.58579C32.9609 6.21071 33.4696 6 34 6C34.5304 6 35.0391 6.21071 35.4142 6.58579C35.7893 6.96086 36 7.46957 36 8V10Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              Full Control of the Robot
            </h4>
            <p className="text-base text-center px-8">
              Turn your bot on or off anytime, putting you in charge of your
              trading activities.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34 19.9999V35.9999H30V19.9999H18V35.9999H14V19.9999C12.4087 19.9999 10.8826 20.632 9.75736 21.7572C8.63214 22.8825 8 24.4086 8 25.9999V29.9999C8 31.5912 8.63214 33.1173 9.75736 34.2425C10.8826 35.3677 12.4087 35.9999 14 35.9999H34C35.5913 35.9999 37.1174 35.3677 38.2426 34.2425C39.3679 33.1173 40 31.5912 40 29.9999V25.9999C40 24.4086 39.3679 22.8825 38.2426 21.7572C37.1174 20.632 35.5913 19.9999 34 19.9999ZM18.34 15.9999H29.66C29.244 14.8315 28.4767 13.8205 27.4634 13.1056C26.45 12.3907 25.2402 12.0069 24 12.0069C22.7598 12.0069 21.55 12.3907 20.5366 13.1056C19.5233 13.8205 18.756 14.8315 18.34 15.9999ZM14.2 15.9999C14.663 13.7426 15.891 11.7143 17.6765 10.2578C19.4621 8.80132 21.6957 8.00586 24 8.00586C26.3043 8.00586 28.5379 8.80132 30.3235 10.2578C32.109 11.7143 33.337 13.7426 33.8 15.9999H34C36.6522 15.9999 39.1957 17.0534 41.0711 18.9288C42.9464 20.8042 44 23.3477 44 25.9999V29.9999C44 32.652 42.9464 35.1956 41.0711 37.0709C39.1957 38.9463 36.6522 39.9999 34 39.9999H14C11.3478 39.9999 8.8043 38.9463 6.92893 37.0709C5.05357 35.1956 4 32.652 4 29.9999V25.9999C4 23.3477 5.05357 20.8042 6.92893 18.9288C8.8043 17.0534 11.3478 15.9999 14 15.9999H14.2Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              Real-Time Analytics
            </h4>
            <p className="text-base text-center px-8">
              Gain actionable insights with real-time data to track performance
              and optimize your trading strategy.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <svg
              width="36"
              height="36"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.232 27.4981L16 9.89612L13.768 27.4961H6C4.896 27.4961 4 26.6221 4 25.5441C4.00633 25.0197 4.22048 24.5192 4.59544 24.1525C4.97041 23.7857 5.47555 23.5828 6 23.5881H10.232L12.032 9.41612C12.3 7.27212 14.3 5.75212 16.49 6.01612C18.31 6.23612 19.742 7.63612 19.968 9.41612L21.766 23.5881H25.714L28 38.0801L30.284 23.5901H42C43.104 23.5901 44 24.4661 44 25.5461C44 26.6261 43.104 27.5001 42 27.5001H33.716L31.954 38.6741C31.8162 39.5035 31.4178 40.2674 30.8165 40.855C30.2152 41.4426 29.4423 41.8234 28.61 41.9421C26.426 42.2721 24.384 40.8081 24.046 38.6741L22.286 27.5001H18.23L18.232 27.4981Z"
                fill="#302571"
              />
            </svg>
            <h4 className="text-base font-bold text-[#21272A] mt-6 text-center">
              24/7 Automated Trading
            </h4>
            <p className="text-base text-center px-8">
              Our bots operate round the clock, seizing opportunities even when
              you’re offline.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedPartner;
